module.exports = __webpack_public_path__ + "img/house.766c70b6.svg";